import React, {useEffect, useState} from "react";
import {useDevice} from "../components/device/DeviceProvider";
import {useLocation, useNavigate} from "react-router-dom";
import Layout from "../layout/Layout";
import {useLoading} from "../components/loading/LoadingProvider";
import {isBeforeDate, isNotEmpty} from "../utils/CommonUtil";
import {fetchPost, post} from "../utils/FetchUtil";
import {isCardDesignTemp, isMessageTemp, isQrSettingTemp, isWrapTemp} from "../const/TemplateConst";
import {toast} from "react-toastify";
import {isQrType, isSealType} from "../const/GiftSendTypeConst";
import TemplateListModal from "../modal/TemplateListModal";
import QrFormatSettingModal from "../modal/QrFormatSettingModal";
import ProcessConfirmModal from "../modal/ProcessConfirmModal";
import {img} from "../utils/ImageUtil";
import {url} from "../utils/UrlsUtil";
import OrderDetailTemplate from "./OrderDetailTemplate";
import {OrderPngDownload, OrderUrlSendHistory} from "./OrderOnlineSendArea";
import "../../style/order/order_history_list.scss";
import {Button, Image} from "react-bootstrap";
import {useAuth} from "../components/auth/AuthProvider.tsx";
import DeliveryDateTimeInput from "../components/input/DeliveryDateTimeInput.tsx";
interface OrderHistoryListPageProps{

}

const OrderHistoryListPage:React.FC<OrderHistoryListPageProps> = (
    {

    }
) => {
    const { isMobile } = useDevice();
    const { loginDto } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const breadcrumbList = ["過去のご注文"];
    const { showLoading, hideLoading } = useLoading();
    const [errorList, setErrorList] = useState([]);
    const [orderList, setOrderList] = useState<OrderInputLineDto[]>([]);

    const [showTempListModal, setShowTempListModal] = useState(false);
    const [searchTemplateDto, setSearchTemplateDto] = useState<OrderInputTemplateDto | undefined | null>(undefined);

    const [showQrSettingModal, setShowQrSettingModal] = useState(false);
    const [selectedQrSettingDto, setSelectedQrSettingDto] = useState<OrderInputTemplateDto | undefined | null>(undefined);

    useEffect(() => {
        initPage();
    }, [loginDto]);
    useEffect(() => {
        setShowQrSettingModal(selectedQrSettingDto !== undefined && selectedQrSettingDto !== null);
    }, [selectedQrSettingDto]);
    useEffect(() => {
        setShowTempListModal(searchTemplateDto !== undefined && searchTemplateDto !== null);
    }, [searchTemplateDto]);
    useEffect( () => {
        setErrorList([]);
    }, [orderList]);

    useEffect(() => {
        initPage();
    }, []);
    const initPage = () => {
        showLoading();
        post<any>({
            action: "/api/order/history",
            data: {},
        })
            .then((data) => {
                if(data !== null && isNotEmpty(data["order_line_list"])){
                    setOrderList(data["order_line_list"]);
                }else{
                    setOrderList([]);
                }
            })
            .catch((reason) => {
                console.log(reason)
                setOrderList([]);
            })
            .finally(() => {
                hideLoading();
            });
    };
    const handleClickDetailTemplate = (dto:OrderInputTemplateDto) => {
        if(isQrSettingTemp(dto.template_kbn)){
            setSelectedQrSettingDto(dto);
        }else{
            setSearchTemplateDto(dto);
        }
    }

    const handleSelectedTemplate = (dto: OrderInputTemplateDto) => {
        setSearchTemplateDto(undefined);
        if(dto.template_id === -1){
            if(isNotEmpty(dto.order_slipnumber)){
                const encodeParams = encodeURIComponent(dto?.order_slipnumber + ";" + dto?.order_detailnumber);
                navigate(`/template/input/${dto?.template_kbn}/?ord=${encodeParams}`, {state: { from: location.pathname } });
            }else{
                navigate(`/template/input/${dto?.template_kbn}`, {state: { from: location.pathname } });
            }
        }else{
            updateOrderDetailTemplate(dto);
        }
    }

    const handleClickEntryMyDesign = (dto:OrderInputTemplateDto | null | undefined) => {
        const encodeParams = encodeURIComponent(dto?.order_slipnumber + ";" + dto?.order_detailnumber);
        navigate(`/template/input/${dto?.template_kbn}/?ord=${encodeParams}`, {state: { from: location.pathname } });
    }

    const handleDeallocatedTemplate = (dto:OrderInputTemplateDto | null | undefined) => {
        if(dto !== null && dto !== undefined){
            updateOrderDetailTemplate(dto);
        }
    }

    const handleQrSettingSaved = (entry_dto) => {
        setSelectedQrSettingDto(undefined);
        const entryTemplate = async () =>{
            showLoading();
            try{
                setErrorList([]);
                const data = await fetchPost({
                    action: "/api/template/qr_settings/entry",
                    data: entry_dto,
                });
                if(data !== null){
                    updateOrderDetailTemplate(data);
                }
            }catch (e) {
                setErrorList([e.message]);
            }finally {
                hideLoading();
            }
        }
        entryTemplate().finally(()=>{});
    }

    const updateOrderDetailTemplate = (template_dto: OrderInputTemplateDto) => {
        const newOrderList = orderList.map(order => {
            const newDetailList = order.detail_list?.map(dtl => {
                if (dtl.slipnumber === template_dto.order_slipnumber &&
                    dtl.detailnumber === template_dto.order_detailnumber) {
                    const updatedDtl = { ...dtl };
                    if (isWrapTemp(template_dto.template_kbn)) {
                        updatedDtl.noshi_template_dto = template_dto;
                    } else if (isCardDesignTemp(template_dto.template_kbn)) {
                        template_dto.ondemand_card_order = dtl.card_template_dto.ondemand_card_order;
                        updatedDtl.card_template_dto = template_dto;
                    } else if (isMessageTemp(template_dto.template_kbn)) {
                        updatedDtl.message_template_dto = template_dto;
                    } else if (isQrSettingTemp(template_dto.template_kbn)) {
                        updatedDtl.qr_template_dto = template_dto;
                    }
                    return updatedDtl;
                }
                return dtl;
            });
            return { ...order, detail_list: newDetailList };
        });
        setOrderList(newOrderList);
    }
    return(
        <Layout page_meta = {{title: '過去のご注文｜ギフトアレンジ'}}
                breadcrumb_list={breadcrumbList}
                error_list={errorList}
        >
            <section className="order-history-page-title">
                <h2>
                    過去のご注文
                </h2>
            </section>
            <section className="order-history-list-area">
                {orderList && orderList.length != 0 && orderList.map((orderDto, index) =>
                    <div className="order-line-view" key={`order_line_view_${index}`}>
                        {orderDto.png_type && <div className="delivery-view-block qr-gift">
                            <div className="png-title">
                                <span><img src={url("/images/common/qr_gift.png")}/></span>
                                QRギフト
                            </div>
                            <p className="download-files">
                                <span>ご利用案内書データのダウンロード</span><br className="sp"/>
                                <span className="guide-file"><a href={url('/ug/pngguidedoc')}><img src={url("/images/icon/word_file_icon.png")}/></a></span>
                                <span className="guide-file"><a href={url('/ug/pngguidepdf')}><img src={url("/images/icon/pdf_file_icon.png")}/></a></span>
                            </p>
                        </div>}
                        {(orderDto.eselect_type || orderDto.egift_type) && <div className="delivery-view-block online-gift">
                            <div className="png-title">
                                <span><img src={url("/images/common/online_gift.png")}/></span>
                                オンラインギフト
                            </div>
                        </div>}
                        {orderDto.paper_item_type && <div className="delivery-view-block">
                            <dl>
                                <dt>お届け先</dt>
                                <dd>{orderDto.destination_name}{orderDto.operator_name}</dd>
                            </dl>
                            <dl className="delivery-address">
                                <dt>〒{orderDto.delivery_zipcode1}-{orderDto.delivery_zipcode2}</dt>
                                <dd>{orderDto.delivery_prefecture_name}{orderDto.delivery_address1}　<br/>
                                    {orderDto.delivery_address2}</dd>
                            </dl>
                            <div>
                                <dl className="delivery-request-date">
                                    <dt>お届希望日時</dt>
                                    <dd>{orderDto.delivery_request_text}</dd>
                                </dl>
                                <dl className="ship-date">
                                    <dt>　　　出荷日</dt>
                                    <dd>{orderDto.ship_date}</dd>
                                </dl>
                            </div>
                        </div>}
                        {!isMobile && <div className="ship-view-block">
                            <div className="flex-fill">
                                <p>
                                    {orderDto.paper_item_type && <>
                                        ※オンラインメッセージは、発送後も割り当て可能。
                                        <br/><span className="text-danger">※熨斗包装・オリジナルカードの割り当て・変更は不可。</span>
                                    </>}
                                    {orderDto.png_type && <>
                                        ※オンラインメッセージは、いつも割り当て可能。
                                        <br/><span className="text-danger">※フォーマットが設定・変更が不可。</span>
                                    </>}
                                    {(orderDto.eselect_type || orderDto.egift_type) && <>
                                        ※オンラインメッセージは、いつも割り当て可能。
                                    </>}
                                </p>
                            </div>
                            <dl className="order-template-title-area">
                                <dt>{orderDto.paper_item_type && <>のし・包装</>}</dt>
                                <dt>
                                    {orderDto.paper_item_type && <>オリジナルカード</>}
                                    {orderDto.png_type && <>QRギフトフォーマット</>}
                                </dt>
                                <dt>オンライン・<br/>メッセージ（無料）</dt>
                            </dl>
                        </div>}
                        {orderDto.detail_list && orderDto.detail_list.length != 0 && orderDto.detail_list.map(dtl =>
                            <React.Fragment key={`order_dtl_view_${dtl.slipnumber}_${dtl.detailnumber}`}>
                            <div className="order-detail-view">
                                {!isMobile && <div className="goods-image">
                                    <Image src={`${isNotEmpty(dtl.image_path)? img(dtl.image_path) : url('/images/common/list_noimage.png')}`} fluid></Image>
                                </div>}
                                <div className="flex-fill order-detail-info">
                                    <div className={`goods-info ${(orderDto.egift_type || orderDto.eselect_type)?'online-gift':''}`}>
                                        <p><strong>{dtl.goods_name}</strong></p>
                                        <p>
                                            {dtl.goods_code}
                                            <strong className="float-end send-type-name">{dtl.gift_send_type_name}</strong>
                                        </p>
                                    </div>
                                    <div className="order-numbers">
                                        <p>
                                            <span>注文番号</span><br className="sp"/>
                                            {dtl.slipnumber}
                                        </p>
                                        {dtl.rakuten_order && <p>
                                            <span className="rakuten-mask">楽天</span><br className="sp"/>
                                            {dtl.ext_order_number}
                                        </p>}
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <dl className="justify-content-start">
                                            <dt>注文日</dt>
                                            <dd>{dtl.order_date}</dd>
                                        </dl>
                                        <dl>
                                            <dt>数量</dt>
                                            <dd>{dtl.quant}</dd>
                                        </dl>
                                        <dl>
                                            <dt>購入額</dt>
                                            <dd>{dtl.sale_price_amount}円</dd>
                                        </dl>
                                    </div>
                                    {orderDto.png_type && <OrderPngDownload dtl={dtl}/>}
                                </div>
                                <div className="order-template-area">
                                    {isMobile && <>
                                        <dl className="order-template-sp">
                                            <dt className="flex-fill">
                                                オンライン・<br/>メッセージ（無料）<br/>
                                                <p>※オンラインメッセージは、<br/>発送後も割り当て可能。</p>
                                            </dt>
                                            <dd>
                                                {dtl.message_template_dto &&
                                                    <OrderDetailTemplate dto={dtl.message_template_dto}
                                                                         committed={true}
                                                                         handleClick={handleClickDetailTemplate}
                                                                         handleClickEntry={handleClickEntryMyDesign}
                                                                         handleDeallocated={handleDeallocatedTemplate}
                                                    />
                                                }
                                                {dtl.message_template_dto && isNotEmpty(dtl.message_template_dto.apply_goods_preview_url) &&
                                                    <a href={dtl.message_template_dto.apply_goods_preview_url}
                                                       className="apply-site-preview"
                                                       target="_blank"
                                                    >交換サイト表示</a>
                                                }
                                            </dd>
                                        </dl>
                                        {(dtl.noshi_template_dto) &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    のし・包装<br/>
                                                    <p className="text-danger">※発送済は<br/>割り当て、変更不可。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.noshi_template_dto}
                                                                         committed={true}
                                                    />
                                                </dd>
                                            </dl>}
                                        {(dtl.card_template_dto) &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    オリジナル<br/>カード<br/>
                                                    <p className="text-danger">※発送済は<br/>割り当て、変更不可。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.card_template_dto}
                                                                         committed={true}
                                                    />
                                                </dd>
                                            </dl>}
                                        {isQrType(dtl.gift_send_type_code) && dtl.qr_template_dto &&
                                            <dl className="order-template-sp">
                                                <dt>
                                                    QRギフト<br/>フォーマット<br/>
                                                    <p className="text-danger">※発送済は<br/>設定、変更不可。</p>
                                                </dt>
                                                <dd>
                                                    <OrderDetailTemplate dto={dtl.qr_template_dto}
                                                                         committed={true}
                                                                         seal_type={isSealType(dtl.gift_send_type_code)}
                                                    />
                                                </dd>
                                            </dl>}
                                    </>}
                                    {!isMobile && <dl className="order-template-pc">
                                        <dd>
                                            {dtl.noshi_template_dto &&
                                                <OrderDetailTemplate dto={dtl.noshi_template_dto}
                                                                     committed={true}
                                                />
                                            }
                                        </dd>
                                        <dd>
                                            {dtl.card_template_dto &&
                                                <OrderDetailTemplate dto={dtl.card_template_dto}
                                                                     committed={true}
                                                />
                                            }
                                            {isQrType(dtl.gift_send_type_code) && dtl.qr_template_dto &&
                                                <OrderDetailTemplate dto={dtl.qr_template_dto}
                                                                     committed={true}
                                                                     seal_type={isSealType(dtl.gift_send_type_code)}
                                                />
                                            }
                                        </dd>
                                        <dd>
                                            {dtl.message_template_dto &&
                                                <OrderDetailTemplate dto={dtl.message_template_dto}
                                                                     committed={true}
                                                                     handleClick={handleClickDetailTemplate}
                                                                     handleClickEntry={handleClickEntryMyDesign}
                                                                     handleDeallocated={handleDeallocatedTemplate}
                                                />
                                            }
                                        </dd>
                                    </dl>}
                                </div>

                            </div>
                            {orderDto.eselect_type && <OrderUrlSendHistory dtl={dtl}/>}
                            </React.Fragment>)}
                    </div>
                )}
            </section>
            <section>
                <TemplateListModal show={showTempListModal}
                                   search_dto={searchTemplateDto}
                                   handleSelected={handleSelectedTemplate}
                                   handleClosed={() => {setSearchTemplateDto(undefined)}}
                ></TemplateListModal>
                <QrFormatSettingModal dto={selectedQrSettingDto}
                                      show={showQrSettingModal}
                                      handleSaved={handleQrSettingSaved}
                                      handleClosed={() => {setSelectedQrSettingDto(undefined)}}
                ></QrFormatSettingModal>
            </section>
        </Layout>
    );
};
export default OrderHistoryListPage;